<template>
  <div>
    <!-- CheckboxList -->
    <ul>
      <li v-for="lender in applicationLenders" :key="lender.index">
        <h3>{{ lender.name }}</h3>
        <h3 v-if="!!getLenderTermsHeading(lender.bankId)">
          {{ getLenderTermsHeading(lender.bankId) }}
        </h3>
        <p class="font-weight-bold">
          {{ getLenderTermsIntro(lender.bankId) }}
        </p>
        <ol class="terms">
          <li v-for="term in getLenderTermsText(lender.bankId)">
            {{ term }}
          </li>
        </ol>
        <div v-if="!!getLenderTermsFooterIntro(lender.bankId)">
          <br/>
          <p class="font-weight-bold">
            {{ getLenderTermsFooterIntro(lender.bankId) }}
          </p>
          <ul class="footer-terms">
            <li v-for="term in getLenderTermsFooterTerms(lender.bankId)">
              {{ term }}
            </li>
          </ul>
        </div>
        <LenderSelectionTermsDL
          :pdfUrl="getLenderPDFLink(lender.bankId)"
          @terms-downloaded="setTermsDownloaded(lender.bankId)"
          >{{ getLenderPDFLinkDisplay(lender.bankId) }}</LenderSelectionTermsDL
        >
        <hr />
        <span class="sign-off">
          <input type="checkbox" :id="'checkbox'+lender.bankId" v-model="lender.isCheckboxChecked" @change="updateCheckAll()">
          <label :for="'checkbox'+lender.bankId">I acknowledge the above and agree to e-sign below for {{ lender.name }}</label>
        </span>
      </li>
      <div
        class="lender-signature"
        v-if="this.$store.getters.isTDComplete"
      >
        <h3>Versatile Credit</h3>
        <p>
          By signing your electronic signature below, you ACKNOWLEDGE THE
          RECEIPT OF THE VERSATILE CREDIT TERMS OF SERVICE AND AGREE TO THE
          TERMS AND CONDITIONS OUTLINED IN THE FOLLOWING LINK:
        </p>

        <LenderSelectionTermsDL
          pdfUrl="static/DealerAgreement-versatile.pdf"
          @terms-downloaded="setTermsDownloaded('versatile')"
          >DealerAgreement-versatile.pdf</LenderSelectionTermsDL
        >
        <hr />

        <span class="sign-off">
          <input type="checkbox" id="checkbox-versatile" v-model="versatileCheckboxChecked" @change="updateCheckAll()">
          <label for="checkbox-versatile">I acknowledge the above and agree to e-sign below for Versatile Credit</label>
        </span>
      </div>
    </ul>
  </div>
</template>

<script>
import LenderSelectionTermsDL from '@/components/Application/LenderSelectionTermsDL.vue'
import LenderTermsText from '../../../static/LenderTermsText.json'

export default {
  data() {
    return {
      downloaded: {},
      dealerTermsPdfViewed: false,
      versatileCheckboxChecked: false
    }
  },
  components: {
    LenderSelectionTermsDL,
    LenderTermsText
  },
  computed: {
    applicationLenders() {
      if (this.$store.getters.isAvb) {
        //likely a temporary solution - we don't have all the avb lenders set up yet so display TD terms/esign only
        const tdIdx = this.$store.getters.getDealerApplication.lenders.findIndex(l => l.bankId === "tdbank")
        if (tdIdx >=0) {
          return [this.$store.getters.getDealerApplication.lenders[tdIdx]]
        }
      }

      return this.$store.getters.getDealerApplication.lenders
    }
  },
  methods: {
    getLenderTermsText(bankid) {
      if (LenderTermsText[bankid][this.$store.getters.getDomain]) {
        return LenderTermsText[bankid][this.$store.getters.getDomain].terms
      }
      return LenderTermsText[bankid].terms || LenderTermsText.default.terms
    },
    getLenderTermsIntro(bankid) {
      return LenderTermsText[bankid].intro || LenderTermsText.default.intro
    },
    getLenderTermsHeading(bankid) {
      return LenderTermsText[bankid].heading
    },
    getLenderTermsFooterIntro(bankid) {
      if (LenderTermsText[bankid].footer) {
        return LenderTermsText[bankid].footer.intro
      }
    },
    getLenderTermsFooterTerms(bankid) {
      if (LenderTermsText[bankid].footer) {
        return LenderTermsText[bankid].footer.terms
      }
    },
    getLenderPDFLink(bankId) {
      if (this.$store.getters.isAvb && bankId == 'tdbank') {
        return 'static/DealerAgreement-' + bankId + '-avb.pdf'
      }
      if (this.$store.getters.isTDComplete && bankId == 'tdbank') {
        return 'static/DealerAgreement-' + bankId + '-tdcomplete.pdf'
      }
      return 'static/DealerAgreement-' + bankId + '.pdf'
    },
    getLenderPDFLinkDisplay(bankId) {
      return 'DealerAgreement-' + bankId + '.pdf'
    },
    updateCheckAll() {
      var isCheckAll = true;
      this.applicationLenders.forEach(lender => {
        if (!lender.isCheckboxChecked) {
          isCheckAll = false;
        }
      })

      if (this.$store.getters.isTDComplete && !this.versatileCheckboxChecked) {
        isCheckAll = false;
      }

      this.$emit('change', isCheckAll) //notify container of overall status
    },
    downloadDealerTermsPdf() {
      this.dealerTermsPdfViewed = true
      window.open('static/DealerAgreementV20170518.pdf')
    },
    setTermsDownloaded(provider) {
      this.downloaded[provider] = true
      let allDownloaded = true
      for (const lender in this.downloaded) {
        if (!this.downloaded[lender]) {
          allDownloaded = false
          break
        }
      }
      if (allDownloaded) {
        this.$emit('all-terms-downloaded')
      }
    },
    resetLenderSelections() {
      if (this.applicationLenders) {
        this.applicationLenders.forEach(lender => {
          this.downloaded[lender.bankId] = false
        })

        //default to "versatile downloaded" if not TD Complete
        this.downloaded.versatile = (!this.$store.getters.isTDComplete)
      }
    }
  },
  //this component will mount again each time the lender selection dialog is opened, resetting selections
  //which I think is good (although if they don't change anything, they may be annoyed a bit)
  mounted() {
    this.resetLenderSelections()
  }
}
</script>

<style lang="scss" scoped>
.terms {
  list-style-type: decimal;
  line-height: 1.9rem;
}
.footer-terms {
  list-style-type: disc;
  line-height: 1.9rem;
}
.checkbox {
  margin-top: 1rem;
}
.esign-wrapper {
  margin-bottom: 2rem;
}
.error-message {
  color: red;
}
.lender-signature {
  max-width: 80%;
  h3 {
    line-height: 2rem;
    padding-top: 2rem;
  }
  font-size: 1rem;
  ul li {
    line-height: 0.7rem;
  }
  ol li {
    padding-bottom: 0.7rem;
  }
  p {
    padding-bottom: 0.7rem;
  }
  input[type='checkbox'] {
  }
}
.sign-off {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  .v-input {
    flex: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Application/LenderSelectionEsign.vue